var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M14.166 5.83334H10.8327V7.5H14.166C15.541 7.5 16.666 8.625 16.666 10C16.666 11.375 15.541 12.5 14.166 12.5H10.8327V14.1667H14.166C16.466 14.1667 18.3327 12.3 18.3327 10C18.3327 7.7 16.466 5.83334 14.166 5.83334ZM9.16602 12.5H5.83268C4.45768 12.5 3.33268 11.375 3.33268 10C3.33268 8.625 4.45768 7.5 5.83268 7.5H9.16602V5.83334H5.83268C3.53268 5.83334 1.66602 7.7 1.66602 10C1.66602 12.3 3.53268 14.1667 5.83268 14.1667H9.16602V12.5ZM6.66602 9.16667H13.3327V10.8333H6.66602V9.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.277c08b1e835d4348709fa9d05546fec.svg";
export { ForwardRef as ReactComponent };